export default __webpack_public_path__ + "static/media/ads-mobile-1.9ec089bf.gif";